export default "__VITE_ASSET__18b7898a__"